module.exports = __webpack_public_path__ + "static/media/code.53bc6f68.jpg";